import React ,{ useEffect,useState } from 'react'
import {useParams,useLocation} from 'react-router-dom'
import { projFirestore } from '../../firebase/config';
import Create from '../create/Create';



export default function Edit() {
    const param = useParams();
    const id = param.id;
    const getURL = useLocation().pathname;
    const editCheck = (getURL.includes('edit') && getURL.includes(id))
    const [isPending, setIsPending] = useState(false)
    const [data,setData] = useState(null);
    const [error, setError] = useState(null)
    useEffect(()=>{
        setIsPending(true)
           projFirestore.collection('recipes').doc(id).get().then(snapshot=>{
                
            const data={id,...snapshot.data()}
                setData(data)
                setIsPending(false)
            
        }).catch(err=>{
            setError(err.message)
        })
        
    },[id])
    
  return (
    <div>
    {isPending && <p className='loading'>Loading data...</p>}
      {error && <p className='error'>{error}</p>}
      {  data && <Create editCheck={editCheck} data={data} />}
    </div>
  )
}
